import { Icon } from '@chakra-ui/react';

export const CustomEqualsIcon = (props) => (
  <Icon viewBox="0 0 8 8" fill="none" {...props}>
    <rect
      x="0.636719"
      y="2.5"
      width="6.7"
      height="1.2"
      rx="0.6"
      fill="currentColor"
    />
    <rect
      x="0.636719"
      y="4.5"
      width="6.7"
      height="1.2"
      rx="0.6"
      fill="currentColor"
    />
  </Icon>
);
